// extracted by mini-css-extract-plugin
module.exports = {"forget-password":"_1-u7FTp5","form-actions":"_34IZ3pYn","obs":"UrZJGWKR"};